/**
 * 인증이 필요한 다운로드 엔드포인트(.docx 등)를 fetch+blob으로 받아 저장
 * 3대 AI 기능(리포트/계약서/제안서) 워드 다운로드 공통 유틸
 */
import { API_ORIGIN } from '../config/runtime';

export async function downloadAuthedFile(path: string, filename: string): Promise<void> {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_ORIGIN}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    let message = '다운로드에 실패했습니다.';
    try {
      const data = await res.json();
      message = data.message || message;
    } catch { /* 무시 */ }
    throw new Error(message);
  }
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default downloadAuthedFile;
